export enum FilterCategoryKey {
    priceRange = 'priceRange',
    areaRange = 'areaRange',
    roomRange = 'roomRange',
}
